import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FieldContextMenuModule } from './field-context-menu/field-context-menu.module';
import { ResourceEditFormComponent } from './resource-edit-form.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FieldContextMenuModule],
  declarations: [ResourceEditFormComponent],
  exports: [ResourceEditFormComponent],
})
export class ResourceEditFormModule {}
